import {
    DocumentMagnifyingGlassIcon,
    QueueListIcon,
} from "@heroicons/react/24/outline";
import FailedTicketsIcon from "../../components/shared/icons/faildTicket";

const Complain = [
    {
        path: "complains-management",
        fullPath: "call-center/complains-management",
        exact: true,
        showChildren: true,
        sidebarMenu: true,
        displayName: "Complaints",
        displayPath: "Call Center > Complaints",
        icon: DocumentMagnifyingGlassIcon,
        children: [
            {
                path: "complains",
                fullPath: "call-center/complains-management/complains",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Complaint List",
                displayPath: "Complaints > Complaint List",
                icon: QueueListIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Complain/List"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["callcenter-complain-list"],
                    },
                    {
                        path: "create",
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Complain/Upsert"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["callcenter-complain-create"],
                    },
                    {
                        path: "edit/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Complain/Upsert"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["callcenter-complain-update"],
                    },
                    {
                        path: "view/:id",
                        exact: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Complain/Details"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["callcenter-complain-view"],
                    },
                ],
            },
            {
                path: "failed-tickets",
                fullPath: "call-center/complains-management/failed-tickets",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Failed Tickets",
                displayPath: "Call Center > Failed Tickets",
                icon: FailedTicketsIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Complain/FailedTickets"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["callcenter-failed-tickets-list"],
                    },
                ],
            },
        ],
    },
];

export default Complain;
